import type { FaireProductEntity } from "../../entity_types/product";

export const p_p3y2y58hjg: FaireProductEntity = {
  token: "p_p3y2y58hjg",
  type: "product",
  name: "SUNBURN 4 oz candle",
  brandToken: "b_9bs9zcxru5",
  brandName: "The Sensory Riot",
  imageUrl:
    "https://cdn.faire.com/fastly/36fbce3cab7ca064deb0163d1a5f77f4351936e6681c92b6ce54939178035e7c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bd50b74e1eb573d692aaf5307ddd9710d27643d5f28602d14d24f8db8845fdc.jpeg",
    "https://cdn.faire.com/fastly/7a7b8f3ee5b8bee11a6fefdb878e95395a248b14f62bcfa24212401290e13f79.jpeg",
    "https://cdn.faire.com/fastly/5c0311a76d533ff2b2ada424509716cbe001d7492cf4b5da7731241a75beb1ce.jpeg",
    "https://cdn.faire.com/fastly/bf63cd5039a566fa131f7fe882466af41acd941f66a917d9d600e4392af01645.jpeg",
  ],
  priceDollars: 11,
  description:
    "SALTY · SOLAR · SUN-KISSED · SANDY\n\nA purposely mellow composition that radiates through the room like the sensual golden glow of sunset. Balmy coastal breezes flutter through open windows, carrying the flirtatious warmth of sun-kissed skin, the fading sweetness of tangerine peels, and salty air threaded with coconut husk, sandalwood, clove, and cardamom.  \n\nDaylight slips away as an ambered, sun-touched musk lingers warm, salty, sandy, and glowing. \n\n\nSCENT NOTES\n* dried tangerine peel, cardamom, clove\n* sea salt, coconut husk, soft powder\n* sandalwood, dry woods, sheer musk\n\n\nDETAILS\n* Scented Soy Wax Candle\n* Clean Burning + Non Toxic\n* Braided Cotton Wicks\n* Hand-poured in Los Angeles",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:06.865Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
